import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    margin: 0 1.15rem 0 1.15rem;
`;

export const PageWrapper = styled.div`
    max-width: 450px;
    @media screen and (min-width: 780px) {
        width: 360px;
        top: 30px;
        border: 1px solid #f6f7fb;
        margin: auto;
    }
`;
export const ContentWrapper = styled.div`
    overflow: scroll;
`;
